module.exports = __webpack_public_path__ + "static/img/home_img_y++.3bfcda3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_img_y++.png
// module id = HP7k
// module chunks = 1